import React, { useState } from "react";
import { Box, Popover, Typography, IconButton, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const languages = [
  { code: "de", name: "Deutsch", flag: "../assets/img/flags/de.png" },
  { code: "en", name: "English", flag: "../assets/img/flags/en.png" },
  { code: "es", name: "Español", flag: "../assets/img/flags/es.png" },
  { code: "fr", name: "Français", flag: "../assets/img/flags/fr.png" },
  { code: "pt", name: "Português", flag: "../assets/img/flags/pt.png" },
  { code: "it", name: "Italiano", flag: "../assets/img/flags/it.png" },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lng } = useParams();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const currentLang = languages.find((lang) => lang.code === i18n.language.slice(0, 2)) || languages[0];

  const handleLanguageChange = (lang) => {
    if (lng !== lang.code) {
      const newPath = location.pathname.replace(`/${lng}`, `/${lang.code}`);
      i18n.changeLanguage(lang.code);
      navigate(newPath);
    }
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <img src={require(`../assets/img/flags/${currentLang.code}.png`)} alt={currentLang.name} width={30} height={30} />
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box sx={{ p: 2, maxWidth: 150 }}>
          <Grid container spacing={1}>
            {languages.map((lang) => (
              <Grid
                item
                xs={12}
                key={lang.code}
                sx={{
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "action.hover" },
                  p: 1,
                  borderRadius: 1,
                }}
                onClick={() => handleLanguageChange(lang)}
              >
                <img src={require(`../assets/img/flags/${lang.code}.png`)} alt={lang.name} width={24} height={24} style={{ marginRight: 8 }} />
                <Typography>{lang.name}</Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Popover>
    </Box>
  );
};

export default LanguageSelector;
